import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Package } from 'lucide-react';

export const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t bg-slate-50 dark:bg-slate-950 mt-auto" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main footer row */}
        <div className="py-8 grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-3">
              <Package className="h-6 w-6 text-orange-500" />
              <span className="font-manrope font-bold text-base tracking-tight">Surplify</span>
            </Link>
            <p className="text-xs text-muted-foreground leading-relaxed max-w-xs">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-sm font-semibold mb-3">{t('footer.marketplace')}</h4>
            <nav className="flex flex-col gap-1.5">
              <Link to="/search" className="text-xs text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-search-link">
                {t('nav.search')}
              </Link>
              <Link to="/for-partners" className="text-xs text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-partners-link">
                {t('footer.forPartners')}
              </Link>
              <Link to="/register" className="text-xs text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-register-link">
                {t('nav.register')}
              </Link>
              <Link to="/legal/support" className="text-xs text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-support-link">
                {t('footer.support')}
              </Link>
            </nav>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-semibold mb-3">{t('footer.legalTitle')}</h4>
            <nav className="flex flex-col gap-1.5">
              <Link to="/legal/agb" className="text-xs text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-agb-link">
                {t('footer.agb')}
              </Link>
              <Link to="/legal/impressum" className="text-xs text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-impressum-link">
                {t('footer.impressum')}
              </Link>
              <Link to="/legal/datenschutz" className="text-xs text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-datenschutz-link">
                {t('footer.datenschutz')}
              </Link>
              <Link to="/legal/datenschutzeinstellungen" className="text-xs text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-datenschutzeinstellungen-link">
                {t('footer.datenschutzeinstellungen')}
              </Link>
            </nav>
          </div>
        </div>

        {/* Bottom bar - Mercateo style */}
        <div className="border-t py-4 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-muted-foreground">
            &copy; {year} Surplify. {t('footer.rights')}
          </p>
          <nav className="flex items-center gap-3 flex-wrap justify-center">
            <Link to="/legal/agb" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
              {t('footer.agb')}
            </Link>
            <span className="text-muted-foreground text-xs">|</span>
            <Link to="/legal/impressum" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
              {t('footer.impressum')}
            </Link>
            <span className="text-muted-foreground text-xs">|</span>
            <Link to="/legal/datenschutz" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
              {t('footer.datenschutz')}
            </Link>
            <span className="text-muted-foreground text-xs">|</span>
            <Link to="/legal/datenschutzeinstellungen" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
              {t('footer.datenschutzeinstellungen')}
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
};
